var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Svg, utils } from '@costar/theme-ui';
import { IconContext, DefaultContext } from './icon-context';
export const IconPrivate = React.forwardRef(function IconPrivate(props, ref) {
  const identifier = utils.useUniqueId('icon');

  const elem = conf => {
    const {
      attr,
      size: sizeProp,
      title,
      glowEffect,
      color: colorProp,
      style: styleProp = utils.EMPTY_OBJECT,
      children
    } = props,
          svgProps = __rest(props, ["attr", "size", "title", "glowEffect", "color", "style", "children"]);

    const {
      color: colorConf,
      size: sizeConf,
      style: styleConf = utils.EMPTY_OBJECT
    } = conf || utils.EMPTY_OBJECT;
    const color = colorProp || colorConf;
    const size = sizeProp || sizeConf || '1em'; // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop

    const style = Object.assign(Object.assign({}, styleConf), styleProp);
    return React.createElement(Svg, Object.assign({
      ref: ref
    }, attr, {
      className: "csg-tui-icon-svg",
      style: !utils.isEmptyObject(style) ? style : undefined,
      height: size,
      width: size
    }, Object.assign({
      color
    }, svgProps)), title && React.createElement("title", null, title), glowEffect ? React.createElement(React.Fragment, null, React.createElement("defs", null, React.createElement("filter", {
      id: `glow-${identifier}`
    }, React.createElement("feGaussianBlur", {
      in: "SourceAlpha",
      stdDeviation: "1.2"
    }), React.createElement("feOffset", {
      dx: "0",
      dy: "0",
      result: "offsetblur"
    }), React.createElement("feComponentTransfer", null, React.createElement("feFuncA", {
      type: "linear",
      slope: "0.5"
    })), React.createElement("feMerge", null, React.createElement("feMergeNode", null), React.createElement("feMergeNode", {
      in: "SourceGraphic"
    })))), React.createElement("g", {
      filter: `url(#glow-${identifier})`
    }, children)) : // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, children));
  };

  return IconContext !== undefined ? React.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
});

function Tree2Element(tree) {
  return tree && tree.map((node, i) => React.createElement(node.tag, Object.assign({
    key: i
  }, node.attr), Tree2Element(node.child)));
}

export function GenIcon(data) {
  return function Icon(props) {
    const {
      attr
    } = data !== null && data !== void 0 ? data : {};
    return React.createElement(IconPrivate, Object.assign({
      attr: attr
    }, props), Tree2Element(data.child));
  };
}